<template>
  <v-footer
    dark
    height="auto"
    v-if ="$store.state.isUserLoggedIn"
    >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-actions class="white justify-center">
       <p id="footerSlogan">POWERED BY NXTAGRO AND BLUEDROP</p>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>
<script>
export default {
  methods: {
    navigateTo(route){
      this.$router.push(route)
    },
  }
}
</script>

<style scoped>
  .v-card {
    width: 100% !important;
    z-index: 77777 !important;
  }

  .v-card__actions {
    margin: 0px !important;
    width: 100% !important;
  }

  #footerSlogan {
    font-size: 14px;
    color: #9E9E9E !important;
  }
</style>
